import { render, staticRenderFns } from "./Dropbox.vue?vue&type=template&id=102bd568&scoped=true&"
import script from "./Dropbox.vue?vue&type=script&lang=js&"
export * from "./Dropbox.vue?vue&type=script&lang=js&"
import style0 from "./Dropbox.vue?vue&type=style&index=0&id=102bd568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102bd568",
  null
  
)

export default component.exports